import { z } from 'zod';
import { MAX_INPUT_TEXT_LENGTH } from '@mews/framework';

export const TravelAgencyNumberFormSchema = z.object({
    channelNumber: z
        .string()
        .trim()
        .max(MAX_INPUT_TEXT_LENGTH)
        .nullish()
        .transform((value) => (value === '' ? null : value)),
});

export type TravelAgencyNumberFormValues = z.infer<typeof TravelAgencyNumberFormSchema>;
